const KEY = 'dhtn:reloadedBuild'

export function isChunkLoadError(error: unknown): boolean {
    if (!(error instanceof Error)) return false
    return error.name === 'ChunkLoadError' || [
        'Failed to fetch dynamically imported module',
        'Importing a module script failed',
        'Unable to preload CSS for',
    ].some(message => error.message?.includes(message))
}

/** Both Vite and React use one guard. A failed build gets only one automatic
 * reload per tab; a new hashed entry script gets a fresh recovery opportunity. */
export function recoverStaleChunk(): boolean {
    if (!navigator.onLine) return false
    const build = document.querySelector<HTMLScriptElement>('script[type="module"][src]')?.src ?? window.location.origin
    try {
        if (sessionStorage.getItem(KEY) === build) return false
        sessionStorage.setItem(KEY, build)
    } catch { return false /* A manual retry is safer when the guard cannot persist. */ }
    window.location.reload()
    return true
}
